exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".view-display[data-v-7df2dd06]{height:100%;background-color:var(--c-page-background);padding:80px 10px;overflow:scroll;text-align:center}h2[data-v-7df2dd06]{text-align:center;text-transform:uppercase}h2[data-v-7df2dd06]:after,h2[data-v-7df2dd06]:before{content:\"\";height:.4rem;width:.4rem;margin:0 .5rem .3rem;background-color:#000;border-radius:50%;display:inline-block}@media (min-width:600px){.view-display[data-v-7df2dd06]{padding:80px 60px}}@media (min-width:1200px){.view-display[data-v-7df2dd06]{padding:60px 140px}}.fade-enter-active[data-v-7df2dd06]{transition:all .4s ease}.fade-leave-active[data-v-7df2dd06]{transition:all .4s cubic-bezier(1,.5,.8,1)}.fade-enter[data-v-7df2dd06],.fade-leave-to[data-v-7df2dd06]{opacity:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7df2dd06","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ViewDisplay.vue
// module id = 94
// module chunks = 0